const svgIconPropsCreator = (props) => {
    const isHexColor = color => (new RegExp(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)).test(color);

    const fieldProps = {
      viewBox: "0 0 16 16",
      fontSize: "inherit",
      component: "svg",
    };

    if(isHexColor(props.color)) {
      fieldProps.style = {color: props.color};
    }else {
      fieldProps.color = props.color;
    };
    return fieldProps;
}

export default svgIconPropsCreator;